import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Headers from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import s2 from './Component/s2.png';

const MAPS_URL =
  "https://www.google.com/maps/place/Nickle's+Flooring/@36.6728458,-93.8654706,17z/data=!3m1!4b1!4m6!3m5!1s0x87c8d0f8fb4045b5:0x108a292f87bf7f6c!8m2!3d36.6728458!4d-93.8654706!16s%2Fg%2F1trqhrdd?entry=ttu";

const MAP_EMBED =
  "https://www.google.com/maps?q=36.6728458,-93.8654706&z=17&output=embed";

function Contact() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Headers />

      {/* Page header */}
      <section className="bg-[#803333] text-white py-10 md:py-14">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-2">
            Contact Us
          </h1>
          <p className="text-white/85 text-sm md:text-base max-w-xl mx-auto">
            Get in touch with the flooring professionals at Nickle&apos;s Flooring
          </p>
        </div>
      </section>

      {/* Form + store info */}
      <section className="container mx-auto px-4 py-10 md:py-14">
        <div className="row g-4 align-items-start">
          <div className="col-lg-8">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
              <Request />
            </div>
          </div>

          <div className="col-lg-4">
            <aside className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8 sticky top-4">
              <h2 className="text-xl font-bold text-gray-900 mb-6 pb-3 border-b border-gray-100">
                Store Info
              </h2>

              <div className="space-y-6">
                <div>
                  <div className="flex items-start gap-3 mb-3">
                    <span className="flex-shrink-0 w-9 h-9 rounded-lg bg-[#803333]/10 text-[#803333] flex items-center justify-center">
                      <i className="bi bi-geo-alt-fill" />
                    </span>
                    <div>
                      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">
                        Address
                      </p>
                      <p className="text-gray-800 leading-relaxed">
                        470 State Highway 76
                        <br />
                        Cassville, MO 65625
                      </p>
                    </div>
                  </div>
                  <a
                    href={MAPS_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="btn w-100 text-white d-flex align-items-center justify-content-center gap-2"
                    style={{ backgroundColor: '#803333', borderRadius: '10px' }}
                  >
                    <i className="bi bi-map" />
                    Get directions
                  </a>
                </div>

                <div>
                  <div className="flex items-start gap-3 mb-3">
                    <span className="flex-shrink-0 w-9 h-9 rounded-lg bg-[#803333]/10 text-[#803333] flex items-center justify-center">
                      <i className="bi bi-telephone-fill" />
                    </span>
                    <div>
                      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">
                        Phone
                      </p>
                      <a
                        href="tel:+14178472484"
                        className="text-gray-800 font-medium text-lg no-underline hover:text-[#803333]"
                      >
                        (417) 847-2484
                      </a>
                    </div>
                  </div>
                  <a
                    href="tel:+14178472484"
                    className="btn w-100 text-white d-flex align-items-center justify-content-center gap-2"
                    style={{ backgroundColor: '#803333', borderRadius: '10px' }}
                  >
                    <i className="bi bi-telephone" />
                    Call us
                  </a>
                </div>

                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-9 h-9 rounded-lg bg-[#803333]/10 text-[#803333] flex items-center justify-center">
                    <i className="bi bi-clock-fill" />
                  </span>
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">
                      Hours
                    </p>
                    <ul className="list-none p-0 m-0 text-gray-800 space-y-1">
                      <li className="flex justify-between gap-4">
                        <span className="text-gray-600">Mon–Fri</span>
                        <span>8:30 am – 5 pm</span>
                      </li>
                      <li className="flex justify-between gap-4">
                        <span className="text-gray-600">Saturday</span>
                        <span>By appointment</span>
                      </li>
                      <li className="flex justify-between gap-4">
                        <span className="text-gray-600">Sunday</span>
                        <span>Closed</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="pt-2 border-t border-gray-100">
                  <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">
                    Need a quote?
                  </p>
                  <a
                    href="/free-estimate"
                    className="btn w-100 d-flex align-items-center justify-content-center gap-2 border-2"
                    style={{
                      borderColor: '#803333',
                      color: '#803333',
                      borderRadius: '10px',
                      backgroundColor: 'transparent',
                    }}
                  >
                    Request an estimate
                    <i className="bi bi-arrow-right" />
                  </a>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      {/* Financing banner */}
      <section className="container mx-auto px-4 pb-10">
        <a href="/financing" className="block overflow-hidden rounded-xl shadow-sm hover:shadow-md transition-shadow">
          <img
            src={s2}
            alt="Explore financing options at Nickle's Flooring"
            className="w-full h-auto d-block"
          />
        </a>
      </section>

      {/* Map */}
      <section className="container mx-auto px-4 pb-14">
        <div className="mb-4">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-1">
            Find us
          </h2>
          <p className="text-gray-600 text-sm">
            Visit our showroom in Cassville, Missouri
          </p>
        </div>
        <div className="rounded-xl overflow-hidden shadow-sm border border-gray-100 bg-white">
          <iframe
            src={MAP_EMBED}
            title="Nickle's Flooring location map"
            width="100%"
            height="450"
            style={{ border: 0, display: 'block' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Contact;
